import { render, staticRenderFns } from "./ProductCreatedSuccessComp.vue?vue&type=template&id=1d37ac96&scoped=true"
import script from "./ProductCreatedSuccessComp.vue?vue&type=script&lang=js"
export * from "./ProductCreatedSuccessComp.vue?vue&type=script&lang=js"
import style0 from "./ProductCreatedSuccessComp.vue?vue&type=style&index=0&id=1d37ac96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d37ac96",
  null
  
)

export default component.exports